import React from 'react'
import './Tooltip.css'

const Tooltip = props => {
  const classNames = ['Tooltip']

  return (
    <div className={classNames.join(' ')}>
      {props.children}
    </div>
  )
}

export default Tooltip


// WEBPACK FOOTER //
// ./src/components/library/tooltip/Tooltip.js